// @ts-nocheck
import { Card, CardBody, CardExpandToggler } from '@components/card/card';
import Loading from '@components/Shared/Loader/Loading';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import StaticDashboard from './StaticDashboard';
import useGetDashboardWithPermission from '@hooks/NTX/Dashboard/useGetDashboardWithPermission';
import BuilderDashboard from '@pages/NTX/DashboardManagament/DashboardModule/BuilderDashboard';

const FleetDashboard = () => {
  const { i18n } = useTranslation();
  const { DashboardWithPermission: data } = useGetDashboardWithPermission();

  // الحالة لتحديد الداشبورد الحالي
  const [selectedDashboard, setSelectedDashboard] = useState('main');

  // تصفية الداشبوردات بناءً على moduleId
  const filteredDashboards = data.filter(f => f.moduleId?.toUpperCase() === '0A6C6B89-1D52-4EAA-8D2C-040C74B1F6E0');

  return (
    <>
      {filteredDashboards?.length > 0 && (
        <div className='d-sm-flex align-items-center mb-3'>
          <select
            className='form-select btn btn-outline-theme text-truncate me-3 mb-2 mb-sm-0 w-auto'
            value={selectedDashboard}
            onChange={e => setSelectedDashboard(e.target.value)}
          >
            <option value='main'>{i18n.language === 'ar' ? 'اللوحة الرئيسية' : 'Main Dashboard'}</option>
            {filteredDashboards.map(db => (
              <option key={db.id} value={db.id}>
                {db.name}
              </option>
            ))}
          </select>
        </div>
      )}

      {selectedDashboard === 'main' ? <StaticDashboard /> : <BuilderDashboard dashboardId={selectedDashboard} />}
    </>
  );
};



 
export default FleetDashboard;
